// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"368":"679edee2","379":"defedd0f","422":"84cb4933","746":"9e95cdaf","908":"92582540","960":"496cbd10"}[chunkId] + ".css";
};